import React from "react";

const CheckIcon = ({ fill, ...props }) => {
  return (
    <svg viewBox="0 0 24 24" width={16} height={16}>
      <path
        clipRule="evenodd"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M21.2 5.6l-10 9.6-4.4-4.4"
      />
      <path d="M19.9 13c-.5 3.9-3.9 7-7.9 7-4.4 0-8-3.6-8-8s3.6-8 8-8c1.4 0 2.7.4 3.9 1l1.5-1.5C15.8 2.6 14 2 12 2 6.5 2 2 6.5 2 12s4.5 10 10 10c5.2 0 9.4-3.9 9.9-9h-2z" />
    </svg>
  );
};

export default CheckIcon;
